import { defineSlotRecipe } from '@chakra-ui/react';
import fonts from '../fonts';

const bg = 'rgba(41, 40, 61, 0.9)';

const Toast = defineSlotRecipe({
  slots: ['root', 'indicator', 'title', 'description', 'actionTrigger', 'closeTrigger'],
  base: {
    root: {
      bg,
      boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.05)',
      borderRadius: '12px',
      justifyContent: 'space-between',
      p: '15px 15px 14px 20px',
      minW: '300px',
      w: '330px',
      maxW: '400px',
      color: 'white',
      '&[data-type=success]': { bg },
      '&[data-type=error]': { bg },
      '&[data-type=info]': { bg },
      '&[data-type=warning]': { bg },
    },
    description: {
      color: 'podcastShade200',
      fontSize: '14px',
      lineHeight: '18px',
      fontFamily: fonts.bold,
      wordBreak: 'break-word',
    },
  },
});

export default Toast;
